import React from "react";
import { Collapse, Tag, Typography } from "antd";
import { Sentinel, SentinelExample } from "../../model_gen/sentinel";

const { Title } = Typography;
const { Panel } = Collapse;

interface SentinelInfoProps {
  sentinel: Sentinel;
}

const SentinelInfo: React.FC<SentinelInfoProps> = ({ sentinel }) => {
  return (
    <div>
      <Title level={3}>Sentinel Information</Title>
      <div>
        {Object.entries(sentinel.meta || {}).map(([key, value]) => (
          <Tag key={key} style={{ margin: "4px" }}>
            {`${key}: ${value}`}
          </Tag>
        ))}
      </div>
      <Collapse ghost defaultActiveKey={["directive"]}>
        <Panel
          header={
            <div style={{ fontWeight: 800, fontSize: "16px" }}>Directive</div>
          }
          key="directive">
          <div style={{ padding: "10px", whiteSpace: "pre-wrap" }}>
            {sentinel.sentinel_directive.directive_body.main}
          </div>
        </Panel>
        {sentinel.sentinel_directive.examples &&
          sentinel.sentinel_directive.examples.length > 0 && (
            <>
              {sentinel.sentinel_directive.examples.map(
                (example: SentinelExample, i: number) => (
                  <Panel
                    header={
                      <div style={{ fontWeight: 800, fontSize: "14px" }}>
                        {`${example.example_type} Example`}
                      </div>
                    }
                    key={`example-${i}`}>
                    <div style={{ padding: "10px", whiteSpace: "pre-wrap" }}>
                      {example.example_body}
                    </div>
                  </Panel>
                )
              )}
            </>
          )}
      </Collapse>
    </div>
  );
};

export default SentinelInfo;
